import { useState } from 'react';
import { faqs } from '@/mocks/campusData';
import { SectionHeading } from './common';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="border-y border-stone-200 bg-white/60">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <SectionHeading
              kicker="吃瓜指南"
              title="关于反转与真相的常见问题"
              desc="吃瓜不是只要热闹。这些高频问题，帮你少走弯路、不被带节奏，也能在遇到伤害性内容时知道该怎么处理。"
            />
            <div className="hidden rounded-xl border border-stone-200 bg-[#faf4ea] p-5 md:block">
              <p className="flex items-center gap-2 text-sm font-bold text-stone-900">
                <i className="ri-question-answer-line text-red-600" /> 快速索引
              </p>
              <ul className="mt-3 space-y-2">
                {faqs.map((f, i) => (
                  <li key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(i)}
                      className={`text-left text-[13px] leading-snug transition hover:text-red-700 ${openIdx === i ? 'font-semibold text-red-700' : 'text-stone-600'}`}
                    >
                      Q{i + 1} · {f.q}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="md:col-span-7">
            <div className="space-y-3">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q} className="overflow-hidden rounded-xl border border-stone-200 bg-white">
                    <button
                      type="button"
                      aria-expanded={open}
                      onClick={() => setOpenIdx(open ? null : i)}
                      className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-black ${open ? 'bg-red-600 text-white' : 'bg-stone-100 text-stone-500'}`}
                        >
                          Q{i + 1}
                        </span>
                        <span className="text-sm font-semibold text-stone-800 md:text-base">{f.q}</span>
                      </span>
                      <i className={`ri-arrow-down-s-line text-xl text-stone-400 transition ${open ? 'rotate-180 text-red-600' : ''}`} />
                    </button>
                    {open && (
                      <div className="border-t border-stone-100 px-5 py-4 pl-[60px]">
                        <p className="text-sm leading-relaxed text-stone-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}